"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayTagEntity = void 0;
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
/**
 * Display tag entity representing categorization tags
 * for organizing displays in the advertising platform
 */
class DisplayTagEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    name;
    number_of_displays;
    /**
     * @deprecated
     */
    title;
    /**
     * @deprecated
     */
    description;
    /**
     * @deprecated usar el title como key de la traducción y en description igual
     */
    translations;
    /**
     * @deprecated
     */
    picture_url;
    /**
     * @deprecated
     */
    update_at;
    /**
     * @deprecated
     */
    create_at;
    createdAt;
    updatedAt;
}
exports.DisplayTagEntity = DisplayTagEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Legacy MongoDB ObjectId (deprecated)",
        deprecated: true,
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DisplayTagEntity.prototype, "_id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Unique identifier for the display tag",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DisplayTagEntity.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Name of the display tag",
        example: "LED Display",
    }),
    __metadata("design:type", String)
], DisplayTagEntity.prototype, "name", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Number of displays associated with this tag",
        example: 15,
    }),
    __metadata("design:type", Number)
], DisplayTagEntity.prototype, "number_of_displays", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Title of the tag (deprecated, use name instead)",
        deprecated: true,
        example: "LED Display Technology",
    }),
    __metadata("design:type", String)
], DisplayTagEntity.prototype, "title", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Description of the tag (deprecated)",
        deprecated: true,
        example: "High-quality LED display screens for advertising",
    }),
    __metadata("design:type", String)
], DisplayTagEntity.prototype, "description", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Multi-language translations (deprecated - use title as translation key and description equally)",
        deprecated: true,
        type: "array",
        items: {
            type: "object",
            properties: {
                lang: { type: "string", example: "en" },
                title: { type: "string", example: "LED Display" },
                description: { type: "string", example: "High-quality LED displays" },
            },
        },
    })
    /**
     * @deprecated usar el title como key de la traducción y en description igual
     */
    ,
    __metadata("design:type", Array)
], DisplayTagEntity.prototype, "translations", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Picture URL for the tag (deprecated)",
        deprecated: true,
        example: "https://example.com/images/led-display-tag.jpg",
    }),
    __metadata("design:type", String)
], DisplayTagEntity.prototype, "picture_url", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], DisplayTagEntity.prototype, "update_at", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], DisplayTagEntity.prototype, "create_at", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Creation timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], DisplayTagEntity.prototype, "createdAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Last update timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], DisplayTagEntity.prototype, "updatedAt", void 0);
